import { Pressable, StyleProp, ViewStyle } from "react-native";
import { createStyles, sizes, TextColor } from "../theme";
import { Col, Col1 } from "./col";
import { Icon, IconName } from "./icon";
import { Surface, SurfaceProps, SurfaceVariant } from "./surface";
import { TextBody } from "./text";

const variantToTextColor: Record<SurfaceVariant, TextColor> = {
  default: "onSurface",
  error: "onError",
  info: "onInfo",
  success: "onSuccess",
  warning: "onWarning",
};

export type AlertProps = Omit<SurfaceProps, "children" | "style"> & {
  icon?: IconName;
  message: string;
  onPress?: () => void;
  style?: StyleProp<ViewStyle>;
};

export function Alert({
  icon,
  message,
  onPress,
  small = false,
  variant = "default",
  style,
  ...rest
}: AlertProps) {
  // Vars
  const textColor = variantToTextColor[variant];

  // Render
  return (
    <Pressable onPress={onPress} disabled={!onPress}>
      <Surface
        {...rest}
        small
        variant={variant}
        style={[$.container, small && $.small, style]}
      >
        {!!icon && (
          <Col>
            <Icon name={icon} small={small} color={textColor} />
          </Col>
        )}

        <Col1>
          {message.split("|").map((text, index) => (
            <TextBody small={small} key={`${text}-${index}`} color={textColor}>
              {text}
            </TextBody>
          ))}
        </Col1>

        {!!onPress && <Icon name="arrow-right" em />}
      </Surface>
    </Pressable>
  );
}

const $ = createStyles({
  container: {
    row: 4,
    gap: sizes["2"],
  },
  small: {
    gap: sizes["1"],
  },
});
